export default __webpack_public_path__ + "vwq-icons.66b85c6d.woff";